import type { BagelOptions } from '@bagelink/vue'
import type { PluginOptions } from 'vue-toastification'
import {
	BagelVue,
	DialogPlugin,
	RouterWrapper
} from '@bagelink/vue'
import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import Toast, {
	POSITION,
	useToast
} from 'vue-toastification'

import App from './App.vue'
import router from './router'
import 'vue-toastification/dist/index.css'
import '@bagelink/vue/dist/style.css'

import '@/styles/theme.css'
import '@/styles/main.css'

const app = createApp(App)

app.use(router)
const pinia = createPinia()
pinia.use(({ store }) => {
	store.router = markRaw(router)
})

const toastOptions: PluginOptions = {
	position: POSITION.TOP_RIGHT,
	icon: {
		iconClass: 'icon-font',
		iconChildren: 'info',
		iconTag: 'span',
	},
}
app.use(Toast, toastOptions)

const bagelConfig: BagelOptions = {
	host: import.meta.env.VITE_BAGEL_BASE_URL,
	onError: (err: Error & Record<string, any>) => {
		useToast().error(`${'An Error Occurred'}: ${err.response?.data?.detail ?? err.message}`)
	},
}

app.component('RouterWrapper', RouterWrapper)
app.use(DialogPlugin)

app.use(BagelVue, bagelConfig)
app.mount('#app')
